var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { createTransformer } from 'mobx-utils';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { AspectCssAnimationNamed } from './AspectCssAnimationNamed';
export class AspectCssAnimation {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get app() {
        return this.parent.context.app;
    }
    get animationByName() {
        return createTransformer((animationName) => new AspectCssAnimationNamed(this, animationName));
    }
    get isCssAnimationRunning() {
        const { animationstart, animationend } = this.aspect.aspectEvents.latestEventOfType;
        if (!animationstart)
            return false;
        if (!animationend)
            return true;
        return animationstart.runtimeTime > animationend.runtimeTime;
    }
    get wasNoAnimationYet() {
        return !this.aspect.aspectEvents.latestEventOfType.animationstart;
    }
    get animationstarts() {
        return this.aspect.aspectEvents.eventsOfType('animationstart');
    }
    get animationends() {
        return this.aspect.aspectEvents.eventsOfType('animationend');
    }
}
__decorate([
    memoize
], AspectCssAnimation.prototype, "animationByName", null);
__decorate([
    computed
], AspectCssAnimation.prototype, "isCssAnimationRunning", null);
